module.exports = __webpack_public_path__ + "static/media/volume_off.05330aa5.svg";